module.exports = __webpack_public_path__ + "img/refah.4f41f66f.png";